import React from 'react'
import { MdModeEditOutline } from 'react-icons/md'

function RenderGallery(props) {
  const {
    GalleryImages,
    updateImageSizes,
    dragStart,
    dragEnter,
    drop,
    disableInput,
    removeImage,
    editImage,
  } = props
  return (
    <>
      {GalleryImages && GalleryImages.length !== 0 && (
        <div className='rounded galleryImageContainer'>
          {GalleryImages.map((item, index) => (
            <div
              onDragStart={e => dragStart(e, index)}
              onDragEnter={e => dragEnter(e, index)}
              onDragEnd={drop}
              key={index}
              draggable
            >
              <div className='m-2' style={{ position: 'relative' }}>
                {/* Image with remove and edit buttons */}
                <img
                  src={item.path}
                  alt='poster-url'
                  width='100'
                  height='100'
                  onLoad={updateImageSizes}
                />
                <button
                  className='removeButton'
                  type='button'
                  disabled={disableInput}
                  onClick={() => removeImage(index)}
                >
                  X
                </button>
                <button
                  className='editButtonGallery'
                  type='button'
                  onClick={() => editImage(index)}
                  disabled={disableInput}
                >
                  <MdModeEditOutline />
                </button>
                <label>{item.title}</label>
                <div>
                  {item && item.galleryTags && item.galleryTags.length === 0
                    ? ''
                    : item && item.galleryTags && `Category:${item.galleryTags.toString()}`}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  )
}

export default RenderGallery
